import React, { useState, useEffect, useRef } from 'react';
import { postDataFetcher } from '../../dataFetcher';
import CONFIG_OBJECT from '../../config/config';
import LastPeriod from './ovulation-calculator-landing-page/LastPeriod'
import dateUtils from '../../commonUtils/DateUtils';
import App_Constants from '../../app-constants/App_Constants';
import { withTranslation } from 'react-i18next';
import Paginator from './ovulation-calculator-result/Paginator';
import './ovulation-calculator-css/ovulation-calculator.css';
import './ovulation-calculator-css/ovulation-calculator-mobile.css';
import { isMobile } from 'react-device-detect';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import configData from '../../temp/config';
import OvulationStory from './ovulation-calculator-result/OvulationStory';

let currentMonthCycle = {
	dayValue: new Date().getDate(),
	monthValue: new Date().getMonth(),
	yearValue: new Date().getFullYear(),
	cycleLength: 0,
	periodDuration: 0,
	selectedDate: '',
	isPeriodChange: false,
	isCycleChange: false
}

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

const OvulationCalculator = (props) => {

	const [showResultSection, setShowResultSection] = useState(false);
	const [disableBtn, setDisableBtn] = useState(true);
	const [showForm, setShowForm] = useState(true);
	const [showDesc, setShowDesc] = useState(isMobile ? false : true);
	const [parentCompData, setParentCompData] = useState({});
	const [componentData, setComponentData] = useState({})
	const [showEditForm, setShowEditForm] = useState(false);
	const [ovulationCalcData, setOvulationCalcData] = useState({
		showCalender: false,
		apiData: {},
		hasError: false,
		showDesc: true,
		showForm: true,
		showDefaultResult: true,
		showWarningSection: false
	});
	// Calling Layout Service and Caching the response 
	useEffect(() => {
		let componentData = props.fields
		setComponentData(componentData);
		setParentCompData(props.fields);
	}, [])

	const calculatePeriod = () => {
		// if (enableBtn) {
		let month = Number(currentMonthCycle.monthValue) + 1;
		let data = {
			lastPeriodDate: `${dateUtils.formatDate(month)}-${dateUtils.formatDate(currentMonthCycle.dayValue)}-${currentMonthCycle.yearValue}`,
			periodDuration: Number(currentMonthCycle.periodDuration),
			cycleLength: `${currentMonthCycle.cycleLength}`,
		};

		if (isMobile) {
			setShowDesc(false)
			setShowForm(false)
		}
		let restURL = `${CONFIG_OBJECT.OC_REST_URL}`;
		// Calling REST API Url
		postDataFetcher(`${restURL}${App_Constants.SC_API_KEY}&sc_lang=${localStorage.getItem('language')}`, data)
			.then(res => {
				// console.log(res)
				if (res.data.HasError) {
					setOvulationCalcData({
						hasError: true
					})

				} else {
					// setDisableAddBtn(true);
					setOvulationCalcData({
						showCalender: true,
						apiData: res.data.Data,
						showForm: false,
						// shoeDesc: true
						showWarningSection: data.periodDuration > 8
					});
					// setDisableBtn(true);
					if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = true;
				}
				setShowResultSection(true)
			}, err => {
				// console.log(err);
				setOvulationCalcData({
					hasError: true
				})
			});
		if (isMobile) {
			setShowEditForm(true)
		}
	}

	// This function gets called whenever we changed anything in child component(Drop-down)
	const sendLastPeriodData = (dayValue, monthValue, yearValue, cycleLength, periodDuration, enableBtn, isPeriodChange, isCycleChange) => {
		currentMonthCycle = {
			dayValue: dayValue,
			monthValue: monthValue,
			yearValue: yearValue,
			cycleLength: cycleLength,
			periodDuration: periodDuration,
			isPeriodChange: isPeriodChange,
			isCycleChange: isCycleChange
		}
		console.log(currentMonthCycle)
		// if (currentMonthCycle.yearValue !== 1970)
		if (enableBtn) {
			setDisableBtn(false)
			document.getElementById("calculate-period-button-id").disabled = false;
		}
		document.getElementById("calculate-period-button-id").focus()
		//setDisableBtn(false);
	}

	const enableButton = () => {
		setDisableBtn(false);
	}

	const { t } = props;

	const showMainMenu = () => {
		setShowForm(true);
		setShowEditForm(false)
		setTimeout(function () { window.scrollTo(0, 0); }, 0);
		// setDisableBtn(true);
	}

	const mySubmitHandler = (e) => {
		e.preventDefault()
	}

	const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


	const formRef = useRef(null);
	// const sympRef = useRef(null)
	// const executeSympScroll = () => scrollToRef(sympRef)
	const executeScroll = () => {
		// if(document.getElementsByClassName('form-container test').length)
		scrollToRef(formRef)
	}
	let chooseAnotherGoalText = t('PeriodCalculator_ChooseAnotherGoal');
	const chooseAnotherGoalMobText = {
		__html: chooseAnotherGoalText
	}
	return (
		<>
			<div>
				{componentData.description &&
					<section id="main" data-test="component-ovulation">
						<div className="ovulation-calculator">
							<div className="calculator-body">
								{showDesc &&
									<div className="container">
										<p className="ovulation-intro">
											{componentData.description.value}
										</p>
									</div>}

								<div className="goals-section container-mobile">
									{showEditForm && <div className="recalculate-wrap-period-form">
									<div className="container">
										<div className="fdlp-mobile">
											<img src={`${configData.sitecoreApiHost}${parentCompData.firstIcon.value.src}`} />
											<span>{parentCompData.lastperiodLabel.value}</span>
											<span>{currentMonthCycle.dayValue} {months[currentMonthCycle.monthValue]}, {currentMonthCycle.yearValue}</span>
										</div>
										<div
										 className="cycle-length-mobile">
											<span>{parentCompData.periodDayLabel.value}</span><span>{currentMonthCycle.cycleLength} {props.t('PeriodCalculator_DaysLabel')}</span></div>
										<button onClick={showMainMenu}>
											<img src={`${configData.sitecoreApiHost}${parentCompData.secondIcon.value.src}`} />
											<span>Edit</span>
										</button>
										</div>
									</div>}
								</div>
								<div className={"form-container test"} ref={formRef}>
									{showForm && <form role="form" className="form-inline" onSubmit={mySubmitHandler}>
										<div className="toolform container">
											{<>
												<LastPeriod sendLastPeriodData={sendLastPeriodData}
													parentCompData={parentCompData}
													currentMonthCycle={currentMonthCycle} />
												<div className="submitBtnWrapper">
													<div className="ovulBtnWrapper">
														<button type="submit" id="calculate-period-button-id" className="btn red calculate-button" onClick={calculatePeriod} disabled={disableBtn}>
															{t('OvulationCalculator_CalculateButton')}
														</button>
													</div>
												</div>
											</>}
										</div>

									</form>}
									{!isMobile &&
										<hr className="form-divider"></hr>
									}
									{showResultSection && <>
										<div className="container">
											<div className="result-section">
												{ovulationCalcData.showCalender && <div className="higlight-dates">
													<span>{props.t('OvulationCalculator_YourNextOvulationFallsOn')} </span>
													<p>{ovulationCalcData.apiData.firstOvulationDate}</p>
												</div>}

												<div className="calendar">
													{/* Here passing the Period Calculator Result
                							This Paginator Component automatically handles all the Pagination */}
													{ovulationCalcData.showCalender &&
														<Paginator result={ovulationCalcData.apiData} showMainMenu={showMainMenu} sendLastPeriodData={sendLastPeriodData}
															parentCompData={parentCompData}
															currentMonthCycle={currentMonthCycle}
														/>
													}
												</div>
											</div>
										</div>
										<div className="container">
											<OvulationStory ovulationStory={parentCompData.ovulationStory} />
										</div>
									</>}
								</div>

							</div>
							<div className="social-share-container">
								<div className="container">
									<Placeholder name="social-share" rendering={props.rendering} itemid={props.itemid} />

								</div>
							</div>
							
						</div>

					
					</section>
				}
			</div>
			<div className="period-calculator-note-section">
				<p>{componentData.disclaimerMessage && componentData.disclaimerMessage.value}</p>
			</div>

		</>
	)
}

export default withTranslation()(OvulationCalculator);
